// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.etmhxlinMU8vTAsZ24IV {
    height: calc(100vh - 148px);
    width: 100%;
   display: block;
      overflow: auto;
  position: relative;

}

.iEVe7c3IBdtR7B8BmDLw {
    overflow-y: scroll;
    height: calc(100vh - 106px);
}

.SIlGJPvlfUuCj6_XK3xB {
    display: table;
    text-align: left;
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
 height: 100%; 
}
.ZqX70kqVDAcfv_aBYbOu {
    cursor: pointer;
    background-color: var(--white);
    height: 1px; 
}
.ZqX70kqVDAcfv_aBYbOu:not(:first-child) {
    border-top: 1px solid var(--disabled-bg);
}


.ZqX70kqVDAcfv_aBYbOu:hover {
    background-color: var(--disabled-bg);
}

.SIlGJPvlfUuCj6_XK3xB thead {
    background-color: var(--background);
    border-radius: 20px;
}

.SIlGJPvlfUuCj6_XK3xB th,
.SIlGJPvlfUuCj6_XK3xB td {
    height: 50px;
    white-space: wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Chrome/Safari/Opera */
    user-select: none; /* Non-prefixed version, currently*/
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
}

/* /* .desktop_spreadsheet td:nth-child(2) {
        max-width: 120px;
} */
.SIlGJPvlfUuCj6_XK3xB td:not(:first-child),
.SIlGJPvlfUuCj6_XK3xB td:not(::nth-child(2))   {
        width: calc( 100%/8);
}
.SIlGJPvlfUuCj6_XK3xB td:nth-child(7) {
        min-width: 140px;
} 

@media (max-width: 1239px) {
    .SIlGJPvlfUuCj6_XK3xB th {
        height: 40px;
        /* width: 120px; */
    }
}


.NDTHKsYnxSe9WyCTHDqH {
    margin-left: 5px;
    color: var(--blue);
    transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1);
}

.NDTHKsYnxSe9WyCTHDqH:hover {
    color: var(--vivid-pink);
    transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1);
}

thead tr th {
    position: sticky;
    top: 0;
    z-index: var(--table);
}
.SIlGJPvlfUuCj6_XK3xB tbody {
  height: 100%;
}
.SIlGJPvlfUuCj6_XK3xB tbody tr:last-child td {
  height: 100%;
}
.nMS48JMXhgvLZLJJ6ybp {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 70vw;
}

.a4v8svfGgtjF3J7gC0jw {
    overflow: hidden;
    text-overflow: ellipsis;
}


.DHGivaplhkxiMXX6wXVZ {
    width: 100%;
    max-width: 100%
}

.SIlGJPvlfUuCj6_XK3xB th:first-child {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}
.SIlGJPvlfUuCj6_XK3xB th:last-child {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}

.SIlGJPvlfUuCj6_XK3xB td:nth-child(n+3) {
    padding-left: 1vw;
}

/* .desktop_spreadsheet th:not(:first-child) {
    min-width: 120px;
} */

.SIlGJPvlfUuCj6_XK3xB th:nth-child(n+3) {
    padding-left: 20px;
}


.SIlGJPvlfUuCj6_XK3xB th {
    font-family: "Mulish", Sans-Serif, serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.2;
    color: var(--disabled-btn-bg);
    background-color: var(--disabled-bg);
}
@media (max-width: 1239px) {
    .SIlGJPvlfUuCj6_XK3xB th {
        font-size: 12px;
    }
}

.L3uj4cDPdq2KEDAHWAgl {
    height: 100%;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.XshbXHTGBF_LWtpVWgSB {
    height: 100%;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: right;
}

.SIlGJPvlfUuCj6_XK3xB td {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    color: var(--black);
    white-space: nowrap;
}
@media (max-width: 1239px) {
    .SIlGJPvlfUuCj6_XK3xB td {
        font-size: 12px;
    }
}


.SIlGJPvlfUuCj6_XK3xB td:last-child,
.SIlGJPvlfUuCj6_XK3xB th:last-child {
    padding-right: 2vw;
    width: 100%;
}

.SIlGJPvlfUuCj6_XK3xB .IJw47eUxXiyG4lVJyi2e {
    color: var(--orange);
    background-color: rgba(245, 177, 0, 0.2);
    border-radius: 2px;
    padding: 0.2em 0.5em;
    /*font-weight: 400;*/
    font-size: 13px;
    line-height: 1.62;
}

.SIlGJPvlfUuCj6_XK3xB .UUEw1zfRQijQy6Oqir5U {
    color: var(--green);
    background-color: rgba(35, 135, 0, 0.2);
    border-radius: 2px;
    padding: 0.2em 0.5em;
    /*font-weight: 700;*/
    line-height: 1.62;
    font-size: 13px;
}

/* --------------mobile------------- */
.H9J0ud8fpDoqEP3molKx {
    height: 100%;
    overflow: auto;
    /* padding: 10px; */
    /* box-shadow: 5px 4px 30px 0 #848C9C4D; */
}

.haMtM4WuJKQ1stQWzRUJ {
    width: 100%;
    height: 100%;
}

.qfFryesUlix3Y86LCJUa {
    padding-bottom: 72px;
}

.p1GQDK0cEpSmitBKI1t0 {
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 2fr;
    gap: 6px 3vw;
    padding: 8px 0;
    /* background-color: var(--white); */
    border-bottom: 1px solid var(--background);;
}

.haMtM4WuJKQ1stQWzRUJ
.c98WcboRHGkpb7UBBQUA {
    position: absolute;
    height: 20px;
    width: 20px;
    border: 1px solid var(--dark-gray);
    border-radius: 5px;
    cursor: pointer;
    left: 0;
    transform: translateX(0%); /* need important */
    transition: background-color 0.08s ease-in;
}

.haMtM4WuJKQ1stQWzRUJ
.k1tEUrsRTvpVg0x_CCwO {
    position: absolute;
    height: 20px;
    width: 20px;
    border-radius: 5px;
    left: 0;
    transform: translateX(0%); /* need important */
    transition: background-color 0.08s ease-in;
    border: 1px solid var(--disabled-bg);
    cursor: default;
}


.haMtM4WuJKQ1stQWzRUJ
.nMS48JMXhgvLZLJJ6ybp,
.haMtM4WuJKQ1stQWzRUJ .YJKoAZhVqNEIc4tKbOjP {
    white-space: wrap;
    overflow: hidden;
    /* text-overflow: ellipsis; */
    width: 65vw;
}


.haMtM4WuJKQ1stQWzRUJ .IJw47eUxXiyG4lVJyi2e {
    background-color: rgba(245, 177, 0, 0.2);
    border-radius: 2px;
    font-size: 13px;
    padding: 0.2em 0.5em;
    color: var(--orange);
}

.haMtM4WuJKQ1stQWzRUJ .UUEw1zfRQijQy6Oqir5U {
    color: var(--green);
    background-color: rgba(35, 135, 0, 0.2);
    border-radius: 2px;
    padding: 0.2em 0.5em;
    font-size: 13px;
}

.nhJtp9pjMU9S4kVynX36 {
    font-size: 10px;
}

.UUEw1zfRQijQy6Oqir5U, .IJw47eUxXiyG4lVJyi2e {
    white-space: nowrap;
}

.haMtM4WuJKQ1stQWzRUJ
[type="checkbox"] {
    width: 20px;
    height: 20px;
    cursor: pointer;
    opacity: 0;
    z-index: var(--table);
}

/* ------------------------------------ */

[type="checkbox"] {
    width: 44px;
    height: 50px;
    cursor: pointer;
    opacity: 0;
    z-index: 1;
    border: none;
}

[type="datetime-local"] {
    border: none;
    width: 60px;
    height: 50px;
    cursor: default;
    opacity: 0;
    z-index: 1;
}


.AEcS5Zm9eS_039591drc {
    position: relative;
    display: flex;
    /* align-content: center; */
    align-items: center;
    width: 44px;
}

.c98WcboRHGkpb7UBBQUA {
    position: absolute;
    height: 20px;
    width: 20px;
    border: 1px solid var(--disabled-btn-bg);
    border-radius: 5px;
    cursor: pointer;
    /*transform: translateX(-20px);*/
    transform: translateX(-50%);
    left: 50%;
    transition: background-color 0.08s ease-in;
}

[type="checkbox"]:checked + .c98WcboRHGkpb7UBBQUA,
[type="checkbox"]:indeterminate + .c98WcboRHGkpb7UBBQUA {
    background-color: var(--blue);
    border-color: var(--blue);
}

/* Style the checkmark/indicator */
[type="checkbox"]:checked + .c98WcboRHGkpb7UBBQUA::after {
    content: "";
    position: absolute;
    border: solid rgb(255, 255, 255);
    border-width: 0 2px 2px 0;
    display: block;
    left: 5px;
    top: 2px;
    width: 6px;
    height: 9px;
    /*-webkit-transform: rotate(35deg);*/
    -ms-transform: rotate(35deg);
    transform: rotate(35deg);
    transition: background-color 0.08s ease-in;

}


[type="checkbox"]:indeterminate + .c98WcboRHGkpb7UBBQUA::after {
    content: "";
    position: absolute;
    border-bottom: 2px solid rgb(255, 255, 255);
    display: block;
    left: 4px;
    top: 8px;
    width: 10px;
    height: 2px;
    box-sizing: border-box;
}


.MrbkVcoHOwIU9e1xEsTE {
    padding-left: 15px;
    min-width: 135px;
}

.FwLg4xnEI4sd2YzSQU5V {
    width: 100%;
    height: 90%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.k1tEUrsRTvpVg0x_CCwO {
    position: absolute;
    height: 20px;
    width: 20px;
    border: 1px solid var(--disabled-bg);
    border-radius: 5px;
    transform: translateX(-50%);
    left: 50%;
    background-color: var(--disabled-bg);
    cursor: default;
}

.mPxYtfd775TOKcvabiN0 {
    position: relative;
    display: flex;
    /* align-content: center; */
    align-items: center;
    cursor: default !important;
}
@media (min-width: 1440px) {

    [type="checkbox"] {
        width: 40px;
        height: 40px;
    }

.AEcS5Zm9eS_039591drc {
    margin-right: 5px;
}
}

/* .docTime {
    width: 70px;
    word-wrap: break-word;
} */
.Jje8k3VUq6alnRXMSeJD{
    min-width: 140px;
    width: max-content;
    max-width: 10vw;
}
.a4v8svfGgtjF3J7gC0jw {
    min-width: 120px;
    width: max-content;
    max-width: 18vw;
    overflow: hidden;
    text-overflow: ellipsis; 
}
.YDrqyeIFXhs_KIREactL {
    min-width: 100px;
    width: max-content;
    max-width: 12vw;
    overflow: hidden;
}

.vqaRhZkhW3BxLSjQZPf8 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
}

.vqaRhZkhW3BxLSjQZPf8 .DB7HQvz6haqzQJThDCEy {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.15s;
    flex-shrink: 0;
}

.vqaRhZkhW3BxLSjQZPf8:hover .DB7HQvz6haqzQJThDCEy {
    opacity: 1;
    pointer-events: auto;
}

.YJKoAZhVqNEIc4tKbOjP {
    max-width: 14vw;
    white-space: wrap;
    width: max-content;
    overflow: hidden;
    text-overflow: ellipsis; 
}
@media (max-width: 1439px) {
    .SIlGJPvlfUuCj6_XK3xB td {
        white-space: wrap;
    }
    .YDrqyeIFXhs_KIREactL {
        width: 12vw;
    }
    
    .a4v8svfGgtjF3J7gC0jw,
    .YJKoAZhVqNEIc4tKbOjP {
        overflow: hidden;
        text-wrap: wrap;
    }
    .lJn8oZMYKbB3zd_Kf6Qz {
        width: 80px;
        word-wrap: break-word;
    }
}
@media (max-width: 800px) {
    .a4v8svfGgtjF3J7gC0jw,
    .YJKoAZhVqNEIc4tKbOjP {
        max-width: 100%;
        overflow: hidden;
        text-wrap: wrap;
    }
}


.SIlGJPvlfUuCj6_XK3xB {
  border-collapse: collapse;
  width: 100%;
}

.CrVYy8gn2g02rAERhcJR td {
    position: sticky;
    bottom: 0px;
    z-index: var(--table);
    padding-left: -10px;
    color: var(--disabled-btn-bg);
    font-weight: 700;
    background-color: var(--background);
    height: 32px;
}

.CrVYy8gn2g02rAERhcJR td:first-child {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}
.CrVYy8gn2g02rAERhcJR td:last-child {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}

.b0K9DVeFt14GtG1vJPz2 {
  font-weight: bold;
    color: var(--disabled-btn-bg);
  white-space: nowrap;
}

.etmhxlinMU8vTAsZ24IV::-webkit-scrollbar-track {
    /* box-shadow: inset 0 0 4px var(--sidebar-hover);  */
    margin-top: 50px;
    margin-bottom: 34px;
  }

  .KJ85tzJGzB3f3d6hPxoh {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    font-size: 16px;
    width: 40px;
    color: var(--disabled-btn-bg);
  }
.Z7BuxBECnJ_eiNL5LglP{
    position: fixed;
    bottom: 84px;
    background-color: var(--background);
    width: calc(100vw - 24px); 
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 5px;
    padding: 0 6px;
    left: 12px;
}`, "",{"version":3,"sources":["webpack://./src/styles/Spreadsheet/Spreadsheet.module.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,WAAW;GACZ,cAAc;MACX,cAAc;EAClB,kBAAkB;;AAEpB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;CACd,YAAY;AACb;AACA;IACI,eAAe;IACf,8BAA8B;IAC9B,WAAW;AACf;AACA;IACI,wCAAwC;AAC5C;;;AAGA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,wBAAwB;IACnD,iBAAiB,EAAE,mCAAmC;IACtD,sBAAsB,EAAE,YAAY;IACpC,qBAAqB,EAAE,2BAA2B;AACtD;;AAEA;;GAEG;AACH;;QAEQ,oBAAoB;AAC5B;AACA;QACQ,gBAAgB;AACxB;;AAEA;IACI;QACI,YAAY;QACZ,kBAAkB;IACtB;AACJ;;;AAGA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,wBAAwB;IACxB,oDAAoD;AACxD;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,qBAAqB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;;AAGA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;AACA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;GAEG;;AAEH;IACI,kBAAkB;AACtB;;;AAGA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,oCAAoC;AACxC;AACA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI;QACI,eAAe;IACnB;AACJ;;;AAGA;;IAEI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,wCAAwC;IACxC,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;AACnB;;AAEA,sCAAsC;AACtC;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,YAAY;IACZ,cAAc;IACd,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,OAAO;IACP,yBAAyB,EAAE,mBAAmB;IAC9C,0CAA0C;AAC9C;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,yBAAyB,EAAE,mBAAmB;IAC9C,0CAA0C;IAC1C,oCAAoC;IACpC,eAAe;AACnB;;;AAGA;;;IAGI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,WAAW;AACf;;;AAGA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,qBAAqB;AACzB;;AAEA,yCAAyC;;AAEzC;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,UAAU;AACd;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,2BAA2B;IAC3B,SAAS;IACT,0CAA0C;AAC9C;;AAEA;;IAEI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA,kCAAkC;AAClC;IACI,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,yBAAyB;IACzB,cAAc;IACd,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,4BAA4B;IAC5B,wBAAwB;IACxB,0CAA0C;;AAE9C;;;AAGA;IACI,WAAW;IACX,kBAAkB;IAClB,2CAA2C;IAC3C,cAAc;IACd,SAAS;IACT,QAAQ;IACR,WAAW;IACX,WAAW;IACX,sBAAsB;AAC1B;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,2BAA2B;IAC3B,SAAS;IACT,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,0BAA0B;AAC9B;AACA;;IAEI;QACI,WAAW;QACX,YAAY;IAChB;;AAEJ;IACI,iBAAiB;AACrB;AACA;;AAEA;;;GAGG;AACH;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;IACf;;IAEA;;QAEI,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,WAAW;QACX,qBAAqB;IACzB;AACJ;AACA;IACI;;QAEI,eAAe;QACf,gBAAgB;QAChB,eAAe;IACnB;AACJ;;;AAGA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,mCAAmC;IACnC,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;AACA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;EACE,iBAAiB;IACf,6BAA6B;EAC/B,mBAAmB;AACrB;;AAEA;IACI,qDAAqD;IACrD,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,6BAA6B;EAC/B;AACF;IACI,eAAe;IACf,YAAY;IACZ,mCAAmC;IACnC,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,UAAU;AACd","sourcesContent":[".wrapperScroll {\n    height: calc(100vh - 148px);\n    width: 100%;\n   display: block;\n      overflow: auto;\n  position: relative;\n\n}\n\n.generalWrapperScroll {\n    overflow-y: scroll;\n    height: calc(100vh - 106px);\n}\n\n.desktop_spreadsheet {\n    display: table;\n    text-align: left;\n    border-collapse: collapse;\n    border-spacing: 0;\n    width: 100%;\n height: 100%; \n}\n.tableRow {\n    cursor: pointer;\n    background-color: var(--white);\n    height: 1px; \n}\n.tableRow:not(:first-child) {\n    border-top: 1px solid var(--disabled-bg);\n}\n\n\n.tableRow:hover {\n    background-color: var(--disabled-bg);\n}\n\n.desktop_spreadsheet thead {\n    background-color: var(--background);\n    border-radius: 20px;\n}\n\n.desktop_spreadsheet th,\n.desktop_spreadsheet td {\n    height: 50px;\n    white-space: wrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Chrome/Safari/Opera */\n    user-select: none; /* Non-prefixed version, currently*/\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n}\n\n/* /* .desktop_spreadsheet td:nth-child(2) {\n        max-width: 120px;\n} */\n.desktop_spreadsheet td:not(:first-child),\n.desktop_spreadsheet td:not(::nth-child(2))   {\n        width: calc( 100%/8);\n}\n.desktop_spreadsheet td:nth-child(7) {\n        min-width: 140px;\n} \n\n@media (max-width: 1239px) {\n    .desktop_spreadsheet th {\n        height: 40px;\n        /* width: 120px; */\n    }\n}\n\n\n.moreIco {\n    margin-left: 5px;\n    color: var(--blue);\n    transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.moreIco:hover {\n    color: var(--vivid-pink);\n    transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\nthead tr th {\n    position: sticky;\n    top: 0;\n    z-index: var(--table);\n}\n.desktop_spreadsheet tbody {\n  height: 100%;\n}\n.desktop_spreadsheet tbody tr:last-child td {\n  height: 100%;\n}\n.docNamemobi {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 70vw;\n}\n\n.docName {\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n\n.tdDocName {\n    width: 100%;\n    max-width: 100%\n}\n\n.desktop_spreadsheet th:first-child {\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n}\n.desktop_spreadsheet th:last-child {\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n\n.desktop_spreadsheet td:nth-child(n+3) {\n    padding-left: 1vw;\n}\n\n/* .desktop_spreadsheet th:not(:first-child) {\n    min-width: 120px;\n} */\n\n.desktop_spreadsheet th:nth-child(n+3) {\n    padding-left: 20px;\n}\n\n\n.desktop_spreadsheet th {\n    font-family: \"Mulish\", Sans-Serif, serif;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 1.2;\n    color: var(--disabled-btn-bg);\n    background-color: var(--disabled-bg);\n}\n@media (max-width: 1239px) {\n    .desktop_spreadsheet th {\n        font-size: 12px;\n    }\n}\n\n.counterpartiesIconWrapper {\n    height: 100%;\n    width: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.counterpartiesIconWrapper_mob {\n    height: 100%;\n    width: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: right;\n}\n\n.desktop_spreadsheet td {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    color: var(--black);\n    white-space: nowrap;\n}\n@media (max-width: 1239px) {\n    .desktop_spreadsheet td {\n        font-size: 12px;\n    }\n}\n\n\n.desktop_spreadsheet td:last-child,\n.desktop_spreadsheet th:last-child {\n    padding-right: 2vw;\n    width: 100%;\n}\n\n.desktop_spreadsheet .waiting {\n    color: var(--orange);\n    background-color: rgba(245, 177, 0, 0.2);\n    border-radius: 2px;\n    padding: 0.2em 0.5em;\n    /*font-weight: 400;*/\n    font-size: 13px;\n    line-height: 1.62;\n}\n\n.desktop_spreadsheet .signed {\n    color: var(--green);\n    background-color: rgba(35, 135, 0, 0.2);\n    border-radius: 2px;\n    padding: 0.2em 0.5em;\n    /*font-weight: 700;*/\n    line-height: 1.62;\n    font-size: 13px;\n}\n\n/* --------------mobile------------- */\n.wrapperMobi {\n    height: 100%;\n    overflow: auto;\n    /* padding: 10px; */\n    /* box-shadow: 5px 4px 30px 0 #848C9C4D; */\n}\n\n.mobile_spreadsheet {\n    width: 100%;\n    height: 100%;\n}\n\n.short_mobile_spreadsheet {\n    padding-bottom: 72px;\n}\n\n.mobile_spreadsheet_grid {\n    display: grid;\n    width: 100%;\n    grid-template-columns: 1fr 2fr;\n    gap: 6px 3vw;\n    padding: 8px 0;\n    /* background-color: var(--white); */\n    border-bottom: 1px solid var(--background);;\n}\n\n.mobile_spreadsheet\n.checkmark {\n    position: absolute;\n    height: 20px;\n    width: 20px;\n    border: 1px solid var(--dark-gray);\n    border-radius: 5px;\n    cursor: pointer;\n    left: 0;\n    transform: translateX(0%); /* need important */\n    transition: background-color 0.08s ease-in;\n}\n\n.mobile_spreadsheet\n.checkmarkCancelled {\n    position: absolute;\n    height: 20px;\n    width: 20px;\n    border-radius: 5px;\n    left: 0;\n    transform: translateX(0%); /* need important */\n    transition: background-color 0.08s ease-in;\n    border: 1px solid var(--disabled-bg);\n    cursor: default;\n}\n\n\n.mobile_spreadsheet\n.docNamemobi,\n.mobile_spreadsheet .docType {\n    white-space: wrap;\n    overflow: hidden;\n    /* text-overflow: ellipsis; */\n    width: 65vw;\n}\n\n\n.mobile_spreadsheet .waiting {\n    background-color: rgba(245, 177, 0, 0.2);\n    border-radius: 2px;\n    font-size: 13px;\n    padding: 0.2em 0.5em;\n    color: var(--orange);\n}\n\n.mobile_spreadsheet .signed {\n    color: var(--green);\n    background-color: rgba(35, 135, 0, 0.2);\n    border-radius: 2px;\n    padding: 0.2em 0.5em;\n    font-size: 13px;\n}\n\n.type {\n    font-size: 10px;\n}\n\n.signed, .waiting {\n    white-space: nowrap;\n}\n\n.mobile_spreadsheet\n[type=\"checkbox\"] {\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n    opacity: 0;\n    z-index: var(--table);\n}\n\n/* ------------------------------------ */\n\n[type=\"checkbox\"] {\n    width: 44px;\n    height: 50px;\n    cursor: pointer;\n    opacity: 0;\n    z-index: 1;\n    border: none;\n}\n\n[type=\"datetime-local\"] {\n    border: none;\n    width: 60px;\n    height: 50px;\n    cursor: default;\n    opacity: 0;\n    z-index: 1;\n}\n\n\n.check {\n    position: relative;\n    display: flex;\n    /* align-content: center; */\n    align-items: center;\n    width: 44px;\n}\n\n.checkmark {\n    position: absolute;\n    height: 20px;\n    width: 20px;\n    border: 1px solid var(--disabled-btn-bg);\n    border-radius: 5px;\n    cursor: pointer;\n    /*transform: translateX(-20px);*/\n    transform: translateX(-50%);\n    left: 50%;\n    transition: background-color 0.08s ease-in;\n}\n\n[type=\"checkbox\"]:checked + .checkmark,\n[type=\"checkbox\"]:indeterminate + .checkmark {\n    background-color: var(--blue);\n    border-color: var(--blue);\n}\n\n/* Style the checkmark/indicator */\n[type=\"checkbox\"]:checked + .checkmark::after {\n    content: \"\";\n    position: absolute;\n    border: solid rgb(255, 255, 255);\n    border-width: 0 2px 2px 0;\n    display: block;\n    left: 5px;\n    top: 2px;\n    width: 6px;\n    height: 9px;\n    /*-webkit-transform: rotate(35deg);*/\n    -ms-transform: rotate(35deg);\n    transform: rotate(35deg);\n    transition: background-color 0.08s ease-in;\n\n}\n\n\n[type=\"checkbox\"]:indeterminate + .checkmark::after {\n    content: \"\";\n    position: absolute;\n    border-bottom: 2px solid rgb(255, 255, 255);\n    display: block;\n    left: 4px;\n    top: 8px;\n    width: 10px;\n    height: 2px;\n    box-sizing: border-box;\n}\n\n\n.paddingGeneral {\n    padding-left: 15px;\n    min-width: 135px;\n}\n\n.noDocs {\n    width: 100%;\n    height: 90%;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n}\n\n.checkmarkCancelled {\n    position: absolute;\n    height: 20px;\n    width: 20px;\n    border: 1px solid var(--disabled-bg);\n    border-radius: 5px;\n    transform: translateX(-50%);\n    left: 50%;\n    background-color: var(--disabled-bg);\n    cursor: default;\n}\n\n.checkCancelled {\n    position: relative;\n    display: flex;\n    /* align-content: center; */\n    align-items: center;\n    cursor: default !important;\n}\n@media (min-width: 1440px) {\n\n    [type=\"checkbox\"] {\n        width: 40px;\n        height: 40px;\n    }\n\n.check {\n    margin-right: 5px;\n}\n}\n\n/* .docTime {\n    width: 70px;\n    word-wrap: break-word;\n} */\n.docStatus{\n    min-width: 140px;\n    width: max-content;\n    max-width: 10vw;\n}\n.docName {\n    min-width: 120px;\n    width: max-content;\n    max-width: 18vw;\n    overflow: hidden;\n    text-overflow: ellipsis; \n}\n.docCompany {\n    min-width: 100px;\n    width: max-content;\n    max-width: 12vw;\n    overflow: hidden;\n}\n\n.codeCell {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 4px;\n}\n\n.codeCell .copyIcon {\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.15s;\n    flex-shrink: 0;\n}\n\n.codeCell:hover .copyIcon {\n    opacity: 1;\n    pointer-events: auto;\n}\n\n.docType {\n    max-width: 14vw;\n    white-space: wrap;\n    width: max-content;\n    overflow: hidden;\n    text-overflow: ellipsis; \n}\n@media (max-width: 1439px) {\n    .desktop_spreadsheet td {\n        white-space: wrap;\n    }\n    .docCompany {\n        width: 12vw;\n    }\n    \n    .docName,\n    .docType {\n        overflow: hidden;\n        text-wrap: wrap;\n    }\n    .docTime {\n        width: 80px;\n        word-wrap: break-word;\n    }\n}\n@media (max-width: 800px) {\n    .docName,\n    .docType {\n        max-width: 100%;\n        overflow: hidden;\n        text-wrap: wrap;\n    }\n}\n\n\n.desktop_spreadsheet {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.stickyFooter td {\n    position: sticky;\n    bottom: 0px;\n    z-index: var(--table);\n    padding-left: -10px;\n    color: var(--disabled-btn-bg);\n    font-weight: 700;\n    background-color: var(--background);\n    height: 32px;\n}\n\n.stickyFooter td:first-child {\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n}\n.stickyFooter td:last-child {\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n\n.footerAmount {\n  font-weight: bold;\n    color: var(--disabled-btn-bg);\n  white-space: nowrap;\n}\n\n.wrapperScroll::-webkit-scrollbar-track {\n    /* box-shadow: inset 0 0 4px var(--sidebar-hover);  */\n    margin-top: 50px;\n    margin-bottom: 34px;\n  }\n\n  .firstBox {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 2px;\n    font-size: 16px;\n    width: 40px;\n    color: var(--disabled-btn-bg);\n  }\n.stickyFooterMobile{\n    position: fixed;\n    bottom: 84px;\n    background-color: var(--background);\n    width: calc(100vw - 24px); \n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    border-radius: 5px;\n    padding: 0 6px;\n    left: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapperScroll": `etmhxlinMU8vTAsZ24IV`,
	"generalWrapperScroll": `iEVe7c3IBdtR7B8BmDLw`,
	"desktop_spreadsheet": `SIlGJPvlfUuCj6_XK3xB`,
	"tableRow": `ZqX70kqVDAcfv_aBYbOu`,
	"moreIco": `NDTHKsYnxSe9WyCTHDqH`,
	"docNamemobi": `nMS48JMXhgvLZLJJ6ybp`,
	"docName": `a4v8svfGgtjF3J7gC0jw`,
	"tdDocName": `DHGivaplhkxiMXX6wXVZ`,
	"counterpartiesIconWrapper": `L3uj4cDPdq2KEDAHWAgl`,
	"counterpartiesIconWrapper_mob": `XshbXHTGBF_LWtpVWgSB`,
	"waiting": `IJw47eUxXiyG4lVJyi2e`,
	"signed": `UUEw1zfRQijQy6Oqir5U`,
	"wrapperMobi": `H9J0ud8fpDoqEP3molKx`,
	"mobile_spreadsheet": `haMtM4WuJKQ1stQWzRUJ`,
	"short_mobile_spreadsheet": `qfFryesUlix3Y86LCJUa`,
	"mobile_spreadsheet_grid": `p1GQDK0cEpSmitBKI1t0`,
	"checkmark": `c98WcboRHGkpb7UBBQUA`,
	"checkmarkCancelled": `k1tEUrsRTvpVg0x_CCwO`,
	"docType": `YJKoAZhVqNEIc4tKbOjP`,
	"type": `nhJtp9pjMU9S4kVynX36`,
	"check": `AEcS5Zm9eS_039591drc`,
	"paddingGeneral": `MrbkVcoHOwIU9e1xEsTE`,
	"noDocs": `FwLg4xnEI4sd2YzSQU5V`,
	"checkCancelled": `mPxYtfd775TOKcvabiN0`,
	"docStatus": `Jje8k3VUq6alnRXMSeJD`,
	"docCompany": `YDrqyeIFXhs_KIREactL`,
	"codeCell": `vqaRhZkhW3BxLSjQZPf8`,
	"copyIcon": `DB7HQvz6haqzQJThDCEy`,
	"docTime": `lJn8oZMYKbB3zd_Kf6Qz`,
	"stickyFooter": `CrVYy8gn2g02rAERhcJR`,
	"footerAmount": `b0K9DVeFt14GtG1vJPz2`,
	"firstBox": `KJ85tzJGzB3f3d6hPxoh`,
	"stickyFooterMobile": `Z7BuxBECnJ_eiNL5LglP`
};
export default ___CSS_LOADER_EXPORT___;
